export const isNullOrWhitespace = (input?: string | undefined | null) => !input || !input.trim();
